import React from 'react';
import {Grid} from "@material-ui/core";
import {StyledInput} from "../../form/input";
import {TagsSelect} from "../../form/tags-select";
import styled from "styled-components";
import {BoxWrapper} from "../../box-wrapper/box-wrapper";
import {StyledSelect} from "../../form/select";
import {mainCategories} from "../../../data/main-categories";
import {Categories} from "../../categories";
import UploadDropzone from "../../form/upload-dropzone";
import {StyledCheckbox} from "../../form/checkbox";
import {useTranslation} from "react-i18next";
import {newMainCategories} from "../../../data/new-main-categories";

export const AddBookFormStep1: React.FC<Props> = ({form, contentFile, setContentFile, contentFragmentFile, setContentFragmentFile, contentIllustration, setContentIllustration, contentCover, setContentCover, fileError}) => {
    const { t } = useTranslation(['author', 'common']);

    return (
        <Grid
            container
            direction="row"
        >
            <StyledMainGrid container item sm={12} md={6} direction={'column'} spacing={2}>
                <Grid container item direction={'column'} spacing={4}>

                    <Grid container item direction={'column'}>
                        <StyledInput
                            id="title"
                            label={t('addBook.form.title') + " *"}
                            onChange={form.handleChange}
                            value={form.values.title}
                            error={form.errors.title && form.touched.title}
                        />
                    </Grid>

                    <Grid item>
                        <TagsSelect
                            setFieldValue={form.setFieldValue}
                            values={form.values}
                            fieldName={'tags'}
                            label={t('addBook.form.tags') + " *"}
                            error={!!(form.errors.tags && form.touched.tags)}
                        />
                    </Grid>

                    <Grid item style={{maxWidth: '100%'}}>
                        <StyledSelect
                            id={'mainCategory'}
                            label={t('addBook.form.mainCategory') + " *"}
                            onChange={form.handleChange}
                            value={form.values.mainCategory}
                            options={newMainCategories}
                            optionsLabel={(option) => t('common:mainCategories.' + option)}
                            error={form.errors.mainCategory && form.touched.mainCategory}
                        />
                    </Grid>

                    {form.values.mainCategory &&
                        <Grid item style={{maxWidth: '100%'}}>
                            <BoxWrapper title={t('addBook.form.categories') + ' *'}>
                                {form.errors.categories && form.touched.categories &&
                                <StyledErrorP>{t('addBook.form.categoriesError')}</StyledErrorP>
                                }
                                <Categories
                                    selectedCategory={form.values.categories}
                                    mainCategory={form.values.mainCategory}
                                    handleSelectedCategory={(selectedCategory) => {
                                        form.setFieldValue('categories', selectedCategory);
                                    }}
                                />
                            </BoxWrapper>
                        </Grid>
                    }
                </Grid>
            </StyledMainGrid>

            <StyledMainGrid container item sm={12} md={6}>
                <Grid container item direction={'column'} spacing={3}>
                    <Grid item>
                        <UploadDropzone
                            values={form.values}
                            setFieldValue={form.setFieldValue}
                            fieldName={'file'}
                            inputAccept={'application/pdf,application/epub+zip,.txt'}
                            description={t('addBook.form.uploadDesc')}
                            initialValue={contentFile}
                            setInitialValue={setContentFile}
                            info={t('addBook.form.uploadInfo')}
                            error={fileError}
                            wrongFormatError={form.errors.file && form.touched.file}
                        />
                    </Grid>

                    <Grid item>
                        <StyledCheckbox
                            id={"showShortFile"}
                            name={"showShortFile"}
                            onChange={form.handleChange}
                            value={form.values.showShortFile}
                            label={t('addBook.form.showShortFile')}
                        />

                        {form.values.showShortFile &&
                            <UploadDropzone
                                values={form.values}
                                setFieldValue={form.setFieldValue}
                                fieldName={'shortFile'}
                                inputAccept={'application/pdf,application/epub+zip,.txt'}
                                description={t('addBook.form.uploadDesc2')}
                                initialValue={contentFragmentFile}
                                setInitialValue={setContentFragmentFile}
                                info={t('addBook.form.uploadInfo2')}
                                error={false}
                                wrongFormatError={form.errors.shortFile && form.touched.shortFile}
                            />
                        }
                    </Grid>

                    <Grid item>
                        <StyledCheckbox
                            id={"showCover"}
                            name={"showCover"}
                            onChange={form.handleChange}
                            value={form.values.showCover}
                            label={t('addBook.form.showCover')}
                        />

                        {form.values.showCover &&
                        <UploadDropzone
                            values={form.values}
                            setFieldValue={form.setFieldValue}
                            fieldName={'cover'}
                            inputAccept={'image/*'}
                            description={t('addBook.form.uploadCoverDesc')}
                            initialValue={contentCover}
                            setInitialValue={setContentCover}
                            info={t('addBook.form.uploadCoverInfo')}
                            error={false}
                            wrongFormatError={form.errors.cover && form.touched.cover}
                        />
                        }
                    </Grid>

                    <Grid item>
                        <StyledCheckbox
                            id={"showIllustration"}
                            name={"showIllustration"}
                            onChange={form.handleChange}
                            value={form.values.showIllustration}
                            label={t('addBook.form.showIllustration')}
                        />

                        {form.values.showIllustration &&
                        <UploadDropzone
                            values={form.values}
                            setFieldValue={form.setFieldValue}
                            fieldName={'illustration'}
                            inputAccept={'image/*'}
                            description={t('addBook.form.uploadIllustrationDesc')}
                            initialValue={contentIllustration}
                            setInitialValue={setContentIllustration}
                            info={t('addBook.form.uploadIllustrationInfo')}
                            error={false}
                            wrongFormatError={form.errors.illustration && form.touched.illustration}
                        />
                        }
                    </Grid>
                </Grid>
            </StyledMainGrid>
        </Grid>
    );
}

const StyledMainGrid = styled(Grid)`
    padding: 2rem 2rem;
`;

const StyledErrorP = styled('p')`
  color: #f44336;
  margin-top: -5px;
  margin-bottom: 10px;
`;

interface Props {
    form: any,
    contentFile?: string,
    setContentFile?: any,
    contentFragmentFile?: string,
    setContentFragmentFile?: any,
    contentCover?: string,
    setContentCover?: any,
    contentIllustration?: string,
    setContentIllustration?: any,
    fileError: boolean
}
